<template>
  <div
    class="rounded box-border pa-4 mb-5"
    :class="{
      'box-border-brandPrimary': isSelected,
      'hover-box cursor-pointer': isClickable,
    }"
    @click="handleClick"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "RewardCard",
  props: {
    isSelected: {
      type: Boolean,
      default: false,
    },
    isClickable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (this.isClickable) {
        this.$emit("click");
      }
    },
  },
};
</script>

<style scoped>
.box-border {
  border: 2px solid lightgray;
}
.box-border-brandPrimary {
  border-color: var(--v-brandPrimary-base);
}

.hover-box:hover {
  background-color: #eeeeee;
}
</style>
